<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="px-0 blue--text text--darken-1 text-wrap">
                <slot></slot>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="text-h5 blue--text text--darken-1">RATES INFORMATION</span>
            </v-card-title>
            <v-card-text style="max-height: 425px !important;overflow: scroll !important; overflow-x: hidden !important;">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <div class="text-subtitle-1 font-weight-black">
                                {{ RatePlan.rateName }}
                            </div>
                        </v-col>
                        <v-divider class="mx-1"></v-divider>

                        <v-col cols="12">
                            <v-card class="d-flex pa-2 rounded-sm" outlined tile>
                                <div class="text-decoration-underline">
                                    Package details:
                                </div>
                                &nbsp;
                                <br />
                                <div>{{ RatePlan.description }}</div>
                            </v-card>
                        </v-col>
                        <v-divider class="mx-1"></v-divider>

                        <v-col cols="12" class="mb-0 pb-0" >
                            <div class="
                                text-subtitle-2
                                font-weight-black
                                mb-0
                                pb-0
                              ">
                                Rate Breakdown
                            </div>
                        </v-col>
                        <v-col cols="12" class="mx-0 mt-0">
                            <v-row no-gutters class="mx-0" v-for="(price, iprice) in RatePlan.priceList" :key="iprice">
                                <v-col lg="4" md="4" sm="4" xs="6">
                                    {{ formatDate(price.date) }} </v-col>


                                <v-col lg="4" md="4" sm="4" xs="6">Price: {{ price.displayPrice }}
                                    <v-tooltip v-if="(RatePlan.hotDealsType === 'PayStayDeal' && price.description)
                                        || (RatePlan.hotDealsType === 'PercentDiscount' && price.description)
                                        || (RatePlan.hotDealsType === 'AmountDiscount' && price.description)
                                        || (RatePlan.hotDealsType === 'FixedAmount' && price.description)" top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon color="secondary" dark v-bind="attrs" v-on="on" small>
                                                mdi-information
                                            </v-icon>
                                        </template>
                                        <!-- <span>{{ price.hotDealName }}</span>
                                        <br />
                                        <span>{{ price.hotDealDescription }}</span> -->
                                        <span v-if="RatePlan.hotDealsType === 'PayStayDeal'">{{ price.description
                                            }}</span>
                                        <span v-if="RatePlan.hotDealsType === 'PercentDiscount' ||
                                            RatePlan.hotDealsType === 'AmountDiscount'
                                            || RatePlan.hotDealsType === 'FixedAmount'">{{ price.description }}</span>
                                    </v-tooltip>
                                </v-col>
                                <!-- <v-col lg="4" md="4" sm="4" xs="6">
                                    {{price.description}}</v-col> -->
                            </v-row>
                        </v-col>
                        <v-divider class="mx-1"></v-divider>
                        <div
                            >
                            <v-col cols="12" v-if="RatePlan.ratePlanCancellationPolicy">
                                <div class="text-subtitle-2 font-weight-black">
                                    Special policy
                                </div>
                            </v-col>
                            <v-col cols="12" v-if="RatePlan.ratePlanCancellationPolicy">
                                <p v-html="RatePlan.ratePlanCancellationPolicy"></p>
                            </v-col>
                            <v-col cols="12">
                                <div class="text-subtitle-2 font-weight-black">
                                    Others
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <p v-html="RatePlan.cancellationPolicy"></p>
                            </v-col>
                        </div>

                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import moment from "moment";

export default {
    props: {
        RatePlan: {
            type: Object,
            required: true
        },
        IsPackage: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format("dddd Do MMMM");
        },
    }
}
</script>